import React, {useState, useEffect, useRef} from "react";
import ProsSidebarTop from "./ProsSidebarTop";
import ProjectsList from "../containers/ProjectsList";
import {
    MAIN_VIEW_CREATE_MAIN_PROJECT,
    MAIN_VIEW_CREATE_NEW_SUBPROJECT,
    MAIN_VIEW_CUSTOMER_SETTINGS, MAIN_VIEW_SETTINGS,
} from "../containers/Home";
import {isSmallDevice, sideBarState} from "../prodect/ProsCommonUi";
import {prosPopupOpenSendFeedback} from "./ProsPopup";
import {isShowingHelpDesk} from "../prodect/HelpManager";
import * as prosConnect from "./ProsConnect";
import {isMainProjectView} from "./ProsConnect";
import {useOutsideCallback} from "../components/Common";

export default function ProsSidebar(props) {
    const [sidebarOpen, setSidebarOpen] = useState(sideBarState.get().open || false)
    const [sidebarLocked, setSidebarLocked] = useState(isSmallDevice() ? false : (typeof sideBarState.get().locked === 'boolean' ? sideBarState.get().locked : false))
    const sideBarRef = useRef()

    useEffect(()=> {
        sideBarState.set(sidebarOpen, sidebarLocked)
    } , [sidebarOpen, sidebarLocked])

    useEffect(()=> {
        setSidebarOpen(props.isSidebarOpen)
    } , [props.isSidebarOpen])

    function openSideBar(){
        setSidebarOpen(true)
        setSidebarLocked(false)
    }

    function closeSideBar(){
        if(sidebarLocked) return
        setSidebarOpen(false)
    }

    function resetSidebar(){
        setSidebarOpen(false)
        setSidebarLocked(false)
    }

    function toggleLockSidebar(){
        setSidebarLocked(!sidebarLocked)
    }

    function openMainProjectPage(mainProject, view, permSettings){
       props.openMainProjectPage(mainProject, view, permSettings)
       closeSideBar()
    }

    useOutsideCallback(sideBarRef, () => closeSideBar())
    return <div
            ref={sideBarRef}
            className={"sidebar"
                + (sidebarOpen ? " open" : "")
                + (sidebarLocked && sidebarOpen ? " locked" : "")}
        >
        <ProsSidebarTop
            toggleLockSidebar={toggleLockSidebar}
            toggleSidebar={()=> sidebarOpen ? closeSideBar() : openSideBar()}
            sidebarLocked={sidebarLocked}
            sidebarOpen={sidebarOpen}
            resetSidebar={() => resetSidebar()}
            //resetView={() => props.resetView()}
            setMainView={props.setMainView}
        />
        {sidebarOpen ? <div className={"scrollpane-vertical"}>
            <ProjectsList
                history={props.history}
                creatingNewProject={props.currentProjectView === MAIN_VIEW_CREATE_NEW_SUBPROJECT}
                openMainProjectPage={(mainProject, view, permSettings)=> {
                    openMainProjectPage(mainProject, view, permSettings)
                    closeSideBar()
                }}
                createProjectClicked={(refProject, projectCreateViewType) => {
                    props.createProjectClicked(refProject, projectCreateViewType)
                    closeSideBar()
                }}
                projectSelected={projectId => {
                    props.projectSelected(projectId)
                    closeSideBar()
                }}
                mainProjectId={props.mainProjectId}
                currentProjectView={props.currentProjectView}
                isMainProjectView={isMainProjectView(props.currentProjectView)}
                // startEditCustomerData={customerAndProject => {
                //     props.setMainProjectView(MAIN_VIEW_EDIT_CUSTOMER, null, customerAndProject)
                //     closeSideBar()
                // }}
                // launchEditProjectUsers={project_id => {
                //     closeSideBar()
                //     props.launchEditProjectUsers(project_id)
                // }}
                startCreateNewMainProject={()=> {
                    props.createProjectClicked(undefined, MAIN_VIEW_CREATE_MAIN_PROJECT)
                    closeSideBar()
                }}
                closeSideBar={()=> closeSideBar()}
            />
            <SidebarCommonMenu {...props} isSidebarOpen={sidebarOpen} openSideBar={openSideBar} closeSideBar={closeSideBar} />
        </div> : null}
        {!sidebarOpen ? <SidebarCommonMenu {...props} isSidebarOpen={sidebarOpen} openSideBar={openSideBar} closeSideBar={closeSideBar} /> : null}
    </div>
}


function SidebarCommonMenu(props){
    function renderCreateNewProjectButton(){
        return  <li
            onClick={() => {
                props.createProjectClicked(undefined, MAIN_VIEW_CREATE_MAIN_PROJECT)
                props.closeSideBar()
            }}
            className={(props.currentProjectView === MAIN_VIEW_CREATE_MAIN_PROJECT ? "active" : "")
                + (!props.isSidebarOpen ? " tooltip tooltip-right_center" : "")}
            data-tooltip={!props.isSidebarOpen ? "Tilaa uusi projekti" : null}
        >
            <i className={"ui-icon ui-icon-document-add ui-icon_color-light"} />
            <span>Tilaa uusi projekti</span>
        </li>
    }

    function renderShowProjectsButton(){
        if(props.isSidebarOpen) return null
        return <li
            onClick={() => {
                props.openSideBar()
            }}
            className={!props.isSidebarOpen ? " tooltip tooltip-right_center" : ""}
            data-tooltip={!props.isSidebarOpen ? "Näytä projektit" : null}
        >
            <i className={"ui-icon ui-icon-check-list ui-icon_color-light"} />
            <i className={"ui-icon ui-icon-sm ui-icon-chevron-right ui-icon_color-light"} />
        </li>
    }

    const renderSettingsNav =()=> {
        if ( ! prosConnect.getUserAdminCustomers() || prosConnect.getUserAdminCustomers().length < 1) {
            return null
        }
        return <li
                className={"dom-hide dom-show_md"
                    + (!props.isSidebarOpen ? " tooltip tooltip-right_center" : "")}
                data-tooltip={!props.isSidebarOpen ? "Asiakasasetukset" : null}
                onClick={() => {
                    props.setMainView(MAIN_VIEW_CUSTOMER_SETTINGS)
                    props.closeSideBar()
                }}
            >
            <i className={"ui-icon ui-icon_" + (props.isSidebarOpen ? "md" : "") + " ui-icon-group ui-icon_color-" + contentColor}/>
            <span>Asiakasasetukset</span>
        </li>
    }

    const contentColor = "light"
    return <ul className={"navigation"}>
        {renderShowProjectsButton()}
        {renderCreateNewProjectButton()}
        <li
            onClick={() => props.toggleShowingHelpDesk()}
            className={"tooltip tooltip-right_center" + (isShowingHelpDesk() ? " active" : "")}
            data-tooltip={!props.isSidebarOpen ? (isShowingHelpDesk() ? 'Sulje ohje' : 'Näytä ohje') : null}
        >
            {/*Todo Sampo: Help button indicator if help is available for this view {HelpManager.hasViewHelp() && !this.state.showHelpDesk
                ? <i className={"ui-icon ui-icon-xs ui-icon-semantic-disc ui-icon_color-main info-tag"}/> : null}*/}
            <i className={"ui-icon"
                + " ui-icon-help ui-icon_color-"
                + contentColor}/>
            <span>{isShowingHelpDesk() ? 'Sulje ohje' : 'Näytä ohje'}</span>
        </li>
        <li
            onClick={() => {
                props.closeSideBar()
                prosPopupOpenSendFeedback(this)
            }}
            className={!props.isSidebarOpen ? "tooltip tooltip-right_center" : null}
            data-tooltip={!props.isSidebarOpen ? "Lähetä palaute" : null}
        >
            <i className={"ui-icon ui-icon-mail ui-icon_color-" + contentColor}/>
            <span>Lähetä palaute</span>
        </li>
        <li
            onClick={() => {
                props.closeSideBar()
                props.setMainView(MAIN_VIEW_SETTINGS)
            }}
            className={!props.isSidebarOpen ? "tooltip tooltip-right_center" : null}
            data-tooltip={!props.isSidebarOpen ? "Tilin asetukset" : null}
        >
            <i className={"ui-icon ui-icon-user-gear ui-icon_color-" + contentColor}/>
            <span>Tilin asetukset</span>
        </li>
        {renderSettingsNav()}
        <li
            className={"dom-hide dom-show_md"
                + (!props.isSidebarOpen ? " tooltip tooltip-right_center" : "")}
            data-tooltip={!props.isSidebarOpen ? "Kirjaudu ulos" : null}
            onClick={() => {
                props.handleLogout()
            }}
        >
            <i className={"ui-icon ui-icon_" + (props.isSidebarOpen ? "md" : "") + " ui-icon-sign-out ui-icon_color-" + contentColor}/>
            <span>Kirjaudu ulos</span>
        </li>
    </ul>
}